<template>
    <div class="row" id="loginform"  >

        <div class="col-md-12 form-group">
            <h3> เข้าสู่ระบบ </h3>
        </div>
        <form @submit="submitLogin">
        <div class="col-md-12 form-group">
            username:<input ref="hph_user" name="hph_user" type="text"
                   placeholder="กรอกชื่อผู้ใช้งาน"
                   value="">
        </div>
        <div class="col-md-12 form-group">
            password:<input ref="hph_pass" name="hph_pass"
                             type="password" placeholder="กรอกรหัสผ่าน"
                             value="">
        </div>
        <div class="col-md-12 form-group">
            <input  ref="btn_login" class="btn btn-primary btn-sm"
                    name="btn_login" type="submit" value="Login"
                    style="margin-left: 80px"
            >
            <input type="reset" value="Cancle" class="btn btn-primary btn-sm">
        </div>
        </form>

        <div class="col-md-12">
             <span class="resumator-textarea-medium">
                  (ใช้รหัสเดียวกันกับศูนย์แจ้งเตือนภัยฯ)
             </span>
        </div>

        <div class="col-md-12 form-group">
            <a
                    href="http://www.tumdee.org/alert/hph/"
                    class="bigbutton" target="_blank">
                ลงทะเบียน
            </a>&nbsp;
            <a
                    href="http://www.tumdee.org/alert/hph/"
                    class="bigbutton" target="_blank">
                ลืมรหัสผ่าน
            </a>
        </div>
        <div class="col-md-12 form-group">
            <hr/>
        </div>
        <div class="col-md-12 form-group text-center">
            <a href="https://www.thaimushroom.net/mushroom.apk.zip"  download>
            <img src="../assets/mushrooms.png"  style="height: 160px;" >
            <br>
            Download Android App<br>
            (เวอร์ชั่นทดลองใช้)
            </a>
        </div>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    data: function () {
      return {
        msg: 'LoginForm'
      }
    },
    methods: {
      ...mapActions([
        'submitLogin'
      ])
    },
    props: [
      'actionLogin'
    ]
  }
</script>


// WEBPACK FOOTER //
// LoginForm.vue?ce31b41a